import { Pipe, PipeTransform } from '@angular/core';
import { duplicate } from '@util/duplicate';

@Pipe({
  name: 'dup'
})
export class DupPipe<T> implements PipeTransform {
  transform(value: T | T[]): T | T[] {
    if (Array.isArray(value)) {
      return [...value];
    } else if (value) {
      return duplicate<T>(value);
    }
    return value;
  }
}
